<template>
  <div>
    <v-text-field
      outlined
      label="Title"
      messages='Används som alt-text för bilden om beskrivning saknas.'
      v-model="title"
    ></v-text-field>
    <v-text-field
    class="mt-2"
      outlined
      label="Fotograf/Illustratör"
      v-model="copyright"
      messages='Skrivs t.ex. "R. Kautsky", "R. Kautsky/azote.se", eller "Askölaboratoriet/SMF".'
    ></v-text-field>
    <v-textarea
      class="mt-2"
      outlined
      auto-grow
      rows="2"
      label="Plats"
      v-model="location"
      messages='Valfritt, skriv var bilden är tagen. lokalt, regionalt, globalt, t.ex. "Stenskärs norra udde, Trosa skärgård, Östersjön".'
    ></v-textarea>
    <v-textarea
      class="mt-3"
      outlined
      auto-grow
      rows="2"
      label="Beskrivning"
      v-model="altText"
      messages="Skriv in vad bilden förställer (används som alt-text för bilden)."
    ></v-textarea>
    <v-textarea
      class="mt-2"
      outlined
      auto-grow
      rows="2"
      label="Kommentar"
      v-model="comments"
      messages="Ange här t.ex. om bilden är begränsad, vilken typ av begränsningar som gäller, eller andra kommentarer."
    ></v-textarea>
    <v-select
      :items="imageRightsOptions"
      v-model="imageRight"
      label="Rättigheter"
      outlined
      return-object
      item-text="title"
      item-value="id"
      class="my-3"
      hint='Ange endast "allmän" för rättigheter om bilden skall vara fritt tillgänglig inom systemet. Bilder till specifika sidor, med begränsade rättigheter, eller av lågt allmänintresse skall vara "begränsade".'
      persistent-hint
    ></v-select>
    <Keywords v-model="keywords" />
  </div>
</template>

<script>
import Keywords from '../shared/Keywords'

export default {
  name: 'ImageStandard',
  props: {
    image_title: { type: String },
    image_copyright: { type: String },
    image_location: { type: String },
    image_keywords: { type: String },
    image_description: { type: String },
    image_type: { type: String },
    image_text: { type: String },
  },
  components: {
    Keywords,
  },
  data() {
    return {
      imageRightsOptions: [
        { id: 'public', title: 'Allmänt tillgänglig' },
        { id: 'restricted', title: 'Begränsad tillgång' },
        { id: 'azote', title: 'Azote Library' },
      ],
    }
  },
  computed: {
    imageAltText: {
      get() {
        return this.image_alt_text
      },
      set({ id }) {
        this.$emit('update', { image_type: id })
      },
    },
    imageRight: {
      get() {
        return this.image_type
      },
      set({ id }) {
        this.$emit('update', { image_type: id })
      },
    },
    title: {
      get() {
        return this.image_title
      },
      set(val) {
        this.$emit('update', { image_title: val })
      },
    },
    altText: {
      get() {
        return this.image_text
      },
      set(val) {
        this.$emit('update', { image_text: val })
      },
    },
    copyright: {
      get() {
        return this.image_copyright
      },
      set(val) {
        this.$emit('update', { image_copyright: val })
      },
    },
    location: {
      get() {
        return this.image_location
      },
      set(val) {
        this.$emit('update', { image_location: val })
      },
    },
    keywords: {
      get() {
        return this.image_keywords
      },
      set(val) {
        this.$emit('update', { image_keywords: val })
      },
    },
    comments: {
      get() {
        return this.image_description
      },
      set(val) {
        this.$emit('update', { image_description: val })
      },
    },
  },
}
</script>

<style lang="less" scoped></style>
